export default {"src":"/pro/_next/static/media/btc.a7bb970b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};